import { Button } from '@material-ui/core';
import { COLORS } from 'constants/design';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  margin-top: 24px;
  width: 300px;
  height: 40px;
  background-color: ${COLORS.ACCORDION_BG_YELLOW};
  &:hover {
    background-color: ${COLORS.ACCORDION_BG_YELLOW};
  }
`;
